export const API_PREFIX = '/api/v1';

export const LEAD_TEMPERATURES = ['hot', 'warm', 'cold'] as const;
export type LeadTemperature = (typeof LEAD_TEMPERATURES)[number];

export const PRIORITIES = ['low', 'medium', 'high', 'urgent'] as const;
export type Priority = (typeof PRIORITIES)[number];

export const LEAD_STATUSES = ['open', 'won', 'lost'] as const;
export type LeadStatus = (typeof LEAD_STATUSES)[number];

export const LEAD_ACTIVITY_TYPES = ['note', 'call', 'email', 'meeting', 'whatsapp', 'visit'] as const;
export type LeadActivityType = (typeof LEAD_ACTIVITY_TYPES)[number];

export const FOLLOWUP_CHANNELS = ['call', 'email', 'meeting', 'whatsapp', 'visit'] as const;
export type FollowupChannel = (typeof FOLLOWUP_CHANNELS)[number];

export const FOLLOWUP_STATUSES = ['pending', 'completed', 'missed', 'cancelled'] as const;
export type FollowupStatus = (typeof FOLLOWUP_STATUSES)[number];

export const CLIENT_TYPES = ['company', 'individual'] as const;
export const CLIENT_STATUSES = ['active', 'inactive', 'on_hold'] as const;
export type ClientStatus = (typeof CLIENT_STATUSES)[number];

export const TASK_STATUSES = ['todo', 'in_progress', 'in_review', 'blocked', 'done', 'cancelled'] as const;
export type TaskStatus = (typeof TASK_STATUSES)[number];
export const TASK_OPEN_STATUSES: TaskStatus[] = ['todo', 'in_progress', 'in_review', 'blocked'];

export const EMPLOYMENT_TYPES = ['full_time', 'part_time', 'contract', 'intern', 'consultant'] as const;
export type EmploymentType = (typeof EMPLOYMENT_TYPES)[number];

export const EMPLOYEE_STATUSES = ['active', 'probation', 'notice', 'resigned', 'terminated', 'inactive'] as const;
export type EmployeeStatus = (typeof EMPLOYEE_STATUSES)[number];

export const GENDERS = ['male', 'female', 'other', 'undisclosed'] as const;

export const USER_STATUSES = ['active', 'suspended', 'deactivated'] as const;
export type UserStatus = (typeof USER_STATUSES)[number];

export const TENANT_STATUSES = ['active', 'suspended', 'disabled'] as const;
export type TenantStatus = (typeof TENANT_STATUSES)[number];

export const WORK_SESSION_STATES = ['active', 'idle', 'on_break', 'ended'] as const;
export type WorkSessionState = (typeof WORK_SESSION_STATES)[number];

export const WORK_SESSION_END_REASONS = [
  'manual_logout',
  'idle_timeout',
  'heartbeat_lost',
  'admin_forced',
  'session_revoked',
] as const;
export type WorkSessionEndReason = (typeof WORK_SESSION_END_REASONS)[number];

export const SESSION_REVOKE_REASONS = [
  'logout',
  'idle_timeout',
  'heartbeat_lost',
  'admin_forced',
  'password_changed',
  'refresh_reuse',
  'user_deactivated',
  'tenant_suspended',
  'session_limit',
  'expired',
] as const;
export type SessionRevokeReason = (typeof SESSION_REVOKE_REASONS)[number];

/** Machine-readable API error codes returned in `error.code`. */
export const ERROR_CODES = {
  VALIDATION: 'VALIDATION_ERROR',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  SESSION_REVOKED: 'SESSION_REVOKED',
  SESSION_IDLE_TIMEOUT: 'SESSION_IDLE_TIMEOUT',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  DUPLICATE: 'DUPLICATE',
  RATE_LIMITED: 'RATE_LIMITED',
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  TENANT_SUSPENDED: 'TENANT_SUSPENDED',
  INTERNAL: 'INTERNAL_ERROR',
} as const;
export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export const SOCKET_EVENTS = {
  NOTIFICATION: 'notification:new',
  WORK_SESSION_ENDED: 'work-session:ended',
  WORK_SESSION_UPDATED: 'work-session:updated',
  SESSION_REVOKED: 'session:revoked',
} as const;
